import { MapBuilder, px, type Decor, type MapDef } from '../mapdef';

/** Lantern Mall: café, gift shop, department store and restaurant around an atrium. */
const b = new MapBuilder(40, 24, ' ');
b.room(0, 0, 40, 24, ',');
b.room(0, 0, 11, 11, '.'); // café
b.room(10, 0, 11, 11, ':'); // gift shop
b.room(20, 0, 11, 11, ','); // department store
b.room(30, 0, 10, 11, 'k'); // restaurant
for (const x of [5, 6, 15, 16, 25, 26, 34, 35]) b.set(x, 10, 'd');
b.fill(19, 23, 3, 1, 'D');
b.fill(16, 14, 8, 6, ';'); // atrium rug

const box = (tx: number, ty: number, tw: number, h = 10): Decor['solid'] => ({ x: px(tx) + 1, y: px(ty) - h, w: px(tw) - 2, h });
const decor: Decor[] = [
  { kind: 'window', x: px(2), y: 0, w: px(3), wall: true },
  { kind: 'window', x: px(33), y: 0, w: px(3), wall: true },
  { kind: 'menuBoard', x: px(6), y: 2, wall: true },
  { kind: 'cafeTable', x: px(3), y: px(7), solid: box(2, 7, 2, 10) },
  { kind: 'cafeTable', x: px(8), y: px(8), solid: box(7, 8, 2, 10) },
  { kind: 'giftShelf', x: px(12) + 8, y: px(6), w: px(3), solid: box(11, 6, 3, 10) },
  { kind: 'giftShelf', x: px(18) + 8, y: px(6), w: px(3), solid: box(17, 6, 3, 10), variant: 1 },
  { kind: 'clothesRack', x: px(22) + 8, y: px(6), solid: box(21.5, 6, 2, 8) },
  { kind: 'clothesRack', x: px(28) + 8, y: px(6), solid: box(27.5, 6, 2, 8), variant: 1 },
  { kind: 'mannequin', x: px(25) + 8, y: px(4), solid: box(25, 4, 1, 6) },
  { kind: 'diningTable', x: px(33), y: px(7), solid: box(31.5, 7, 3, 10) },
  { kind: 'diningTable', x: px(37), y: px(9), solid: box(35.5, 9, 3, 10) },
  { kind: 'fountain', x: px(20), y: px(18) },
  // Burger Corner seating (life package).
  { kind: 'cafeTable', x: px(2) + 8, y: px(16), solid: box(1.5, 16, 2, 10) },
  { kind: 'cafeTable', x: px(6) + 8, y: px(16), solid: box(5.5, 16, 2, 10) },
  { kind: 'benchIndoor', x: px(12), y: px(18), solid: box(10.5, 18, 3, 6) },
  { kind: 'benchIndoor', x: px(28), y: px(18), solid: box(26.5, 18, 3, 6) },
  { kind: 'pottedPlant', x: px(1) + 8, y: px(22) + 12, solid: { x: px(1) + 2, y: px(22) + 6, w: 12, h: 6 } },
  { kind: 'pottedPlant', x: px(38) + 8, y: px(22) + 12, solid: { x: px(38) + 2, y: px(22) + 6, w: 12, h: 6 } },
  { kind: 'pottedPlant', x: px(15) + 8, y: px(12) + 12, solid: { x: px(15) + 2, y: px(12) + 6, w: 12, h: 6 } },
  { kind: 'pottedPlant', x: px(24) + 8, y: px(12) + 12, solid: { x: px(24) + 2, y: px(12) + 6, w: 12, h: 6 } },
];

export const mall: MapDef = {
  id: 'mall',
  w: b.w,
  h: b.h,
  rows: b.rows(),
  indoor: true,
  theme: { wallFace: '#f6efe2', wallLight: '#fffaf0', wainscot: '#c08048', wallTop: '#3a2a20' },
  doors: [{ tiles: [[19, 23], [20, 23], [21, 23]], to: 'town', arrive: { x: px(74) + 8, y: px(39), facing: 'down' } }],
  decor,
  areas: [
    { key: 'cafe', rect: { x: 0, y: 0, w: px(10), h: px(10) } },
    { key: 'giftShop', rect: { x: px(10), y: 0, w: px(10), h: px(10) } },
    { key: 'dept', rect: { x: px(20), y: 0, w: px(10), h: px(10) } },
    { key: 'restaurant', rect: { x: px(30), y: 0, w: px(10), h: px(10) } },
    { key: 'fastFood', rect: { x: 0, y: px(11), w: px(9), h: px(8) } },
    { key: 'mall', rect: { x: 0, y: 0, w: px(40), h: px(24) } },
  ],
  lights: [5, 15, 25, 35].map((x) => ({ x: px(x), y: px(5), r: 90, color: '255,230,180' })).concat([{ x: px(20), y: px(17), r: 140, color: '255,240,210' }, { x: px(3), y: px(13), r: 80, color: '255,200,120' }, { x: px(37), y: px(12), r: 60, color: '255,120,200' }]),
};
